export default __webpack_public_path__ + "magic-wand.e496c7b0e7e74ab9.svg";